import { Typography, makeStyles,Paper} from "@material-ui/core";
import { Link } from "react-router-dom";

const Politicas = () => {
  const classes = useStyles();
  return (
    
    <div className={classes.root}>
      <Paper className={classes.paper}>
      <Typography variant="h4" className={classes.title} gutterBottom>
        Política de Privacidad
      </Typography>
      <Typography className={classes.bold} gutterBottom>
        Versión Junio 2020
      </Typography>
      <Typography> 
        Desde <span style={{color:'#005795'}}><strong>hygge</strong></span> queremos ofrecer al Usuario una
        experiencia de navegación y un servicio seguro y confiable. Por ello,
        hemos implementado la presente política de privacidad que cumple con las
        medidas de seguridad exigidas por la Ley Orgánica 3/2018, de 5 de
        diciembre, de Protección de Datos Personales y garantía de los derechos
        digitales, y por el Reglamento Europeo de Protección de Datos 679/2016,
        de 27 de abril, relativo a la protección de las personas físicas en lo
        que respecta al tratamiento de datos personales y a la libre circulación
        de estos datos, todo ello con el objetivo de garantizar su privacidad y
        ser transparentes con el uso de sus datos.
        <br/><br/>
        Como ya consta en el Aviso
        <br/> <br/>
        Legal, quien se encuentra detrás de esta Plataforma es:
        <br/> <br/> 
        <span style={{color:'#005795'}}><strong>hygge.SL</strong></span> <br/>
        <strong>NIF: B-0000000</strong> <br/>
        <strong>Domicilio: Av. xxxxxxx xxxxxxx, 16, CP: 15000 de Galicia</strong> <br/>
        <strong>Correo electrónico de contacto: info@spathios.com</strong> <br/> 
        <strong>Teléfono de contacto: 633 000 000</strong> <br/> <br/> 
        Para cualquier cosa que necesite como Usuario en relación con la presente política de privacidad, puede contactar con
        nosotros en el correo electrónico arriba indicado o en nuestra dirección
        física. <br/><br/>
        </Typography>
        <Typography>
        <strong>1. ¿EN QUÉ APARTADOS DE NUESTRA PLATAFORMA RECABAMOS SUS DATOS
        PERSONALES? </strong><br/><br/>
        <strong>a). – A través de nuestro email corporativo</strong><br/><br/>
         A través de nuestra dirección de correo electrónico: info@spathios.com podrá
        escribirnos y/o requerir la información que considere necesaria para
        aclarar las dudas relacionadas con nuestros servicios o sobre el
        funcionamiento de nuestra página web o política de protección de datos,
        así como solicitar asistencia.<br/><br/>
        <strong>b). – A través del formulario de registro</strong>.<br/><br/>
        En el formulario de registro debe rellenar los campos que se le
        solicitan, según vaya a operar en la Plataforma como Usuario anfitrión,
        para lo que facilitará su nombre, o el de su empresa, NIF, DNI de la
        persona encargada, domicilio, teléfono de contacto, número de cuenta
        bancaria y número de la Seguridad Social, dirección de correo
        electrónico y número de teléfono de contacto; o como Usuario huésped,
        proporcionando su nombre, dirección de correo electrónico, número de
        teléfono de contacto y datos bancarios. <br/><br/>
        <strong>c). – A través de las redes</strong><br/><br/>
        sociales Podremos recoger sus datos a través de su perfil de usuario en
        las redes sociales que utilicemos desde Spathios, las cuales están
        detalladas en el apartado 10 de la presente política.<br/><br/> 
        <strong>2. ¿CUÁL ES EL OBJETIVO Y/O FINALIDAD EN LA RECOGIDA DE DATOS?</strong><br/><br/> 
         La inalidad de la recogida de datos en todos los apartados mencionados 
        en el punto anterior es: <br/><br/>
        <div className={classes.ul} >
        <ul>
         <li>Mantener un contacto directo y personalizado con nuestros
        Usuarios. De este modo, usaremos sus datos para atender las dudas o la
        información que nos haya requerido, gestionar sus solicitudes y
        garantizarle una experiencia que respete los máximos estándares. 
        </li><br/><br/>

         <li>También podremos utilizar sus datos con fines de publicidad y de prospección
        comercial, si muestra su consentimiento de manera expresa en el momento
        indicado y en virtud de lo informado en el anterior párrafo.<br/><br/>
       </li>
       <li>
         El email desde el cual nos escriba a nuestro correo corporativo, lo utilizamos
        para remitirle información relacionada con las dudas o inquietudes que
        nos haya planteado, consejos o envío de facturas de compra, según
        corresponda.
        </li>
        </ul>
        </div>
        <br/><br/>
        En ningún caso recibirá información de terceros sin haberle
        informado y solicitado su consentimiento previamente, velando de este
        modo por cumplir con los parámetros de la ley española y la normativa
        europea. <br/><br/>
        Le enviaremos información sobre nuestra empresa, sus acciones,
        eventos, colaboraciones con terceros, acciones comerciales y/o cualquier
        otra iniciativa relacionada con Spathios en función del tipo de
        consentimiento que, en todo caso, nos otorgue.<br/><br/> 
        3. USO DE LOS DATOS PERSONALES Y FINES COMERCIALES <br/><br/>
        hygge comunica a sus Usuarios que los datos personales que nos faciliten serán 
        tratados para las finalidades previstas en el punto 1 y que serán, en detalle, 
        las siguientes: <br/><br/>
        <div className={classes.ul}>
        <ol>
        <li>Atender y resolver las solicitudes o dudas requeridas de los Usuarios;</li> 
        <li>Informar de novedades que podamos contener en la Web;</li> 
        <li>Prestación y facturación de los servicios; Enviar información que se considere que pueda ser de
        interés del Usuario;</li>
        <li>Notificación de los acuerdos promocionales que haya suscrito Spathios con empresas,p
        rofesionales o colaboradores, para ofrecer a los Usuarios de la plataforma determinadas funcionalidades
        diferentes o adicionales a aquellas que hubieran contratado o aceptado;</li>
        <li>Permitir el acceso a las opciones que requieran de registro;</li>
        <li>Enviar comunicaciones comerciales, efectuar acciones de promoción o informarle
        respecto de sus datos de lo siguiente: (i) sus datos no se usarán con
        otros fines que los de llevar a cabo el tratamiento para lo cual
        consintió expresamente en su momento o para lo establecido en la
        presente política por nuestra parte; (ii) toda esta información se
        guarda en un servidor seguro independiente.</li>
        </ol>
        </div>
        <br/><br/>
        Advertirle de que la información que facilite a través de la Página Web 
        puede revelar o permitir que otros deduzcan su nacionalidad, etnia, sexo, edad u otros
        aspectos de su vida privada. De este modo, al facilitar esta información
        de forma totalmente voluntaria a través de cualquier medio de nuestra
        Plataforma, el Usuario está aceptando expresa y voluntariamente esta
        Política de Privacidad y de Protección de Datos de Carácter Personal.<br/><br/>
        <strong>4. COMPARTIR INFORMACIÓN CON TERCEROS</strong><br/><br/>
        Como ya se ha establecido en los
        puntos anteriores, Spathios no facilitará los datos de los Usuarios a
        terceros, entendidos como terceras partes que no tengan vinculación
        directa con el Usuario o que no lleven a cabo una función por cuenta o
        encargo del prestado de servicios o responsable del tratamiento, esto
        es, de Spathios. Por ejemplo, la empresa Stripe, para el procesamiento y
        gestión de los pagos de la Plataforma. En caso de que quisiera hacerlo,
        se le informará previamente y se solicitará su consentimiento.<br/><br/>
        <strong>5. BASE JURÍDICA: CONSENTIMIENTO EXPRESO PARA EL TRATAMIENTO DE SUS DATOS</strong><br/><br/>

        <strong>5.1 Consentimiento de las personas físicas</strong><br/><br/>
        Dando cumplimiento a lo exigido por la Ley Orgánica 3/2018, de 5 de diciembre, 
        de Protección de Datos Personales y garantía de los derechos digitales, y el 
        Reglamento Europeo de Protección de Datos 679/2016 y atendiendo a lo establecido en
        nuestras políticas internas, cada vez que nos envíe datos personales
        deberá dar su consentimiento expreso haciendo click en la casilla que
        aparece en la parte inferior de cada formulario donde se recogen sus
        datos, o cuando nos escribe a nuestro correo electrónico de contacto o
        cualquier otro habilitado para funcionalidades concretas de la
        Plataforma, estará aceptando expresamente que podamos recabar sus datos
        para la finalidad o petición que nos haya indicado. Con dicha(s)
        acción(es), nos está manifestando de forma libre e inequívoca que está
        de acuerdo con que Spathios trate sus datos según las finalidades
        mencionadas en los apartados anteriores. <br/><br/>
        El Usuario garantiza que los datos personales facilitados a Spathios son veraces y se hace
        responsable de comunicar a aquél cualquier modificación de estos.<br/><br/>
        La aceptación del Usuario de que sus datos sean tratados con los fines
        referidos en esta política establecidos tiene siempre carácter
        revocable, sin efectos retroactivos, conforme a lo dispuesto en la
        legislación vigente; por lo tanto, tiene derecho a retirar su
        consentimiento en cualquier momento, sin que ello afecte a la licitud
        del tratamiento basado en su consentimiento previo, mediante los medios
        facilitados en el apartado 6 del presente texto legal. <br/><br/>
        <strong>5.2 Consentimiento de las personas jurídicas o profesionales</strong><br/><br/> 
        Le informamos de que, si actúa en representación de una persona jurídica o como
        profesional independiente, nos autorizará a que le hagamos llegar
        información asociada a los servicios contratados, por un lado, o
        información comercial, en los momentos oportunos a través de la
        aceptación de la presente política de privacidad. Así, cuando solicite
        alguna información relacionada con Spathios por los canales establecidos
        a través de la Plataforma, su información también podrá ser tratada para
        fines comerciales y el envío de comunicaciones electrónicas cuando así
        nos lo haya autorizado mediante las opciones habilitadas.<br/><br/>
        Igualmente, la aceptación del Usuario de que sus datos sean tratados con los fines
        referidos en esta política establecidos tiene siempre carácter
        revocable, sin efectos retroactivos, conforme a lo dispuesto en la
        legislación vigente; por lo tanto, tiene derecho a retirar su
        consentimiento en cualquier momento, sin que ello afecte a la licitud
        del tratamiento basado en su consentimiento previo, mediante los medios
        facilitados en el apartado 6 del presente texto legal. <br/><br/>
        <strong>6. SOBRE SUS DERECHOS DE ACCESO, RECTIFICACIÓN, SUPRESIÓN, OPOSICIÓN, PORTABILIDAD,
        OLVIDO Y LIMITACIÓN EN EL TRATAMIENTO</strong><br/><br/>
        La Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales
        y garantía de los derechos digitales y el Reglamento Europeo de Protección 
        de Datos 679/2016 han implementado una serie de garantías jurídicas que permiten
        al usuario ejercer derechos y acciones relacionados con el tratamiento de sus
        datos.<br/><br/> 
        hygge le ofrece dicha garantía legal, con lo cual, en
        cualquier momento y/o cuando así lo considere conveniente, podrá hacer
        uso de sus derechos de Acceso, Rectificación, Supresión, Oposición,
        Portabilidad, Olvido y Limitación en el tratamiento escribiendo al
        correo electrónico de contacto que hemos habilitado para ello:
        <strong>info@hygge.com</strong>, o enviándonos una solicitud por correo físico 
        a <strong>Av. xxxxxxx xxxxxxx, 16, CP: 15000 de Galicia</strong>, adjuntando, en ambos
        casos, copia del pasaporte o de su DNI (titular de los datos) e
        indicando en el asunto de manera expresa la petición que desea realizar:
        acceso, rectificación, supresión, oposición, portabilidad, olvido o
        limitación en el tratamiento.<br/><br/>
        Es importante que como Usuario tenga en cuenta que la información que haya 
        compartido con Usuarios por cualquier vía podrá continuar siendo visible y que 
        hygge se exonera de toda responsabilidad con relación a la eliminación de esta 
        información.<br/><br/>
        Del mismo modo, Spathios no controla el sistema de renovación de los
        mecanismos de búsqueda de terceros, pudiendo contenerse en dichos
        mecanismos cierta información del perfil público que ya haya sido
        cancelada pero que todavía conste en internet por la redifusión de la
        misma, en cuyo caso, recomendamos se dirija a los responsables de esas
        plataformas para solicitar su cancelación o el ejercicio de un derecho
        al olvido.<br/><br/> 
        Le explicamos brevemente en qué consiste cada uno de los
        derechos que puede ejercer:<br/><br/>
        <strong>Acceso</strong> A través del ejercicio de este
        derecho puede conocer qué datos de carácter personal suyos están siendo
        tratados por nuestra parte; su finalidad, el origen o su posible
        transferencia a terceros. <br/><br/>
        <strong>Rectificación</strong> Consiste en que pueda modificar
        sus datos de carácter personal que sean inexactos o incompletos,
        debiendo especificar en la solicitud qué datos desea que se modifiquen.<br/><br/>
        <strong>Supresión</strong> Permite la cancelación de sus datos personales por inadecuados
        o excesivos.<br/><br/>
        <strong>Oposición</strong> Con el derecho de oposición puede oponerse a que
        no se realice el tratamiento de sus datos en supuestos como: actividades
        de publicidad y prospección comercial o cuando dicho tratamiento tenga
        como fin la adopción de una decisión referida a usted basada únicamente
        en un tratamiento automatizado de sus datos personales.<br/><br/>
        <strong>Portabilidad</strong> Podrá recibir sus datos personales facilitados en un formato
        estructurado, de uso común y lectura mecánica, y poder transmitirlos a
        otro responsable, siempre que sea técnicamente posible.<br/><br/>
        <strong>Olvido</strong> Podrá solicitar la supresión de los datos personales sin dilación debida
        cuando concurra alguno de los supuestos contemplados. Por ejemplo,
        tratamiento ilícito de datos, o cuando haya desaparecido la finalidad
        que motivó el tratamiento o recogida. <br/><br/>
        <strong>Limitación</strong> en el tratamiento En general, en los casos en que no quede claro 
        si los datos personales deberán borrarse, puede ejercer su derecho a limitar el tratamiento.
        Este derecho existe en los casos siguientes: (i) cuando la exactitud de
        los datos de que se trate esté en duda; (ii) cuando como Usuario no
        quiera que se borren los datos, (iii) cuando los datos ya no sean
        necesarios para el fin original, pero no se pueden borrar por motivos
        jurídicos, (iv) cuando la decisión de su objeción al tratamiento esté
        pendiente. La limitación significa que sus datos personales solo pueden
        (salvo la conservación) ser tratados con su consentimiento para la
        formulación, el ejercicio o la defensa de reclamaciones, con miras a la
        protección de los derechos de otra persona física o jurídica o por
        razones de interés público de la UE o de un determinado Estado miembro
        de la UE. Como Usuario debe ser informado antes del levantamiento de
        dicha limitación.<br/><br/>
        Asimismo, como Usuario tiene derecho a presentar una reclamación ante la
        Autoridad de Control competente si considera que el tratamiento de datos 
        personales que le conciernen infringe lo dispuesto en la legislación y 
        normativa de protección de datos; todo ello sin perjuicio de cualquier
        otro recurso administrativo o acción judicial.<br/><br/>
        También, se le informa de que el tratamiento de datos no tendrá por
        objeto tomar decisiones sobre su información basada únicamente en el
        tratamiento automatizado -decisiones automatizadas-, incluida la
        elaboración de perfiles, esto es, no incluye la elaboración de perfiles
        de manera automatizada -y sin intervención humana- de sus datos
        personales para evaluar aspectos personales relativos a su persona,
        tales como analizar o predecir aspectos relacionados con situaciones
        económicas, salud, preferencias o intereses personales, la fiabilidad o
        el comportamiento, la situación del interesado, todo ello en la medida
        en que tenga consecuencias jurídicas para usted o le afecte
        significativamente por ello. En todo caso, solo aplicaría cuando una ley
        lo exigiera y usted tendría dicho tratamiento estará sujeto a las
        garantías apropiadas, entre las que se incluye la información específica
        a su persona, como interesado y el derecho a obtener intervención
        humana, en su caso; también a expresar su punto de vista, a recibir una
        explicación de la decisión tomada después de tal evaluación y a impugnar
        la decisión, cuando ello corresponda.<br/><br/>
        <strong>7. MAYORÍA DE EDAD</strong><br/><br/>
        Para ser Usuario de nuestra Plataforma es necesaria la mayoría de edad, por lo
        que será necesario que sea mayor de 18 años. <br/><br/>
        <strong>8. LAS MEDIDAS DE SEGURIDAD EN LA RECOGIDA DE DATOS</strong><br/><br/>
        Para garantizar la seguridad en nuestra Página Web, hemos integrado un 
        sistema de seguridad que nos permite mantener la confidencialidad y la 
        integridad de los datos de nuestros Usuarios que hayan sido remitidos o
        recogidos a través de los medios mencionados en el primer punto. <br/><br/>
        De este modo, hygge mantiene los niveles de seguridad de protección de sus datos r
        equeridos por la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos
        Personales y garantía de los derechos digitales y el Reglamento Europeo de 
        Protección de Datos 679/2016, de 27 de abril, y ha dispuesto todos los medios
        técnicos a su alcance para evitar la pérdida, mal uso, alteración, acceso no
        autorizado y robo de los datos que el Usuario facilite a través de la Web. <br/><br/>
        También, en calidad de Usuario de nuestra Web entiende, acepta y
        comprende que las medidas de seguridad en internet no son inexpugnables
        y que, por lo tanto, se obliga a adoptar las medidas de seguridad
        necesarias que le permitan confiar en la veracidad de la página web en
        la que está introduciendo sus datos. Nosotros también haremos lo posible
        por garantizar en todo momento la privacidad y seguridad de sus datos
        personales, haciendo uso siempre de la máxima diligencia e implementando
        las medidas que sean necesarias.<br/><br/>
        Así las cosas, le informamos de que será el único responsable sobre las 
        medidas de seguridad que implemente en relación con la protección de sus 
        datos, con lo cual, Spathios no se hace responsable de las situaciones donde el Usuario no haya
        implementado las medidas de seguridad que correspondan; ni de sus
        consecuencias, así como por causas o daños provocados por terceros
        ajenos al negocio, incluyendo casos fortuitos y/o de fuerza mayor. <br/><br/>
        De acuerdo con lo antes establecido, hyggge no puede garantizar que
        terceros no autorizados puedan tener conocimiento de la clase,
        condiciones, características y circunstancias del uso que los Usuarios
        hacen de los servicios ofrecidos en la Plataforma. Sin embargo, como
        medida, sí se han dispuesto unas condiciones de uso en nuestro Aviso
        Legal y Condiciones de Contratación<br/><br/>
        <strong>9. PLAZO DE CONSERVACIÓN DE SUS DATOS PERSONALES</strong><br/><br/>
        Los datos personales proporcionados se conservarán durante el tiempo necesario
        para cumplir con la finalidad para la que se recaban y para determinar las 
        posibles responsabilidades que se pudieran derivar de la finalidad, además 
        de los períodos que se deriven de la legislación aplicable.<br/><br/>
        <strong>10. POLÍTICA EN REDES SOCIALES</strong><br/><br/>
        hygge dispone de un perfil corporativo en Facebook, Instagram y Youtube. Así en virtud
        del Reglamento Europeo de Protección de Datos 679/2016 y en la Ley
        Orgánica 3/2018 de Protección de Datos Personales Spathios es
        “Responsable del tratamiento de sus datos” con motivo de la existencia
        de dichos perfiles en Redes Sociales y el hecho de que nos siga y le
        podamos seguir.<br/><br/>
        Lo anterior significa que si decide unirse a nuestro
        perfil corporativo como un seguidor o dando un “Like” o un “Me gusta” a
        nuestros contenidos o perfil, acepta la presente política, donde le
        explicamos sus derechos y cómo utilizamos sus datos.<br/><br/>
        En calidad de responsable del tratamiento de sus datos garantizamos la
        confidencialidad en el tratamiento y el cumplimiento de sus derechos,
        siempre bajo los efectos de la legislación y normativa citada.
        <br/><br/>Por otra parte, le informamos de que utilizaremos estas redes 
        sociales para anunciar las noticias o información relevante relacionada 
        con nuestro negocio y los servicios que ofrecemos, o bien sobre temas que
        consideramos sean de su interés. Usando las funcionalidades de dichas
        plataformas, es posible que reciba en su muro o en su perfil noticias
        con este tipo de información.<br/><br/>
        Ahora bien, también le hacemos saber que no existe ningún vínculo entre 
        hygge y dichas plataformas o redes sociales, por lo que aceptará su
         política de uso y condiciones una vez
        acceda a las mismas y/o valide sus avisos, términos y condiciones en el
        procedimiento de registro, no siendo responsable Spathios por el uso o
        tratamiento de sus datos que se haga fuera de la estricta relación y
        prestación de servicios indicados en esta política. <br/><br/>
        <strong>11. COOKIES</strong> <br/><br/>
        hyggge utiliza cookies de terceros para el seguimiento y mejora de determinadas
        funcionalidades y servicios. Si quiere consultar cuál es nuestra
        política al respecto, 
        <Link className={classes.link}>clique aquí.</Link> <br/><br/>
        <strong>12. MODIFICACIÓN DE LA PRESENTE POLÍTICA DE PRIVACIDAD</strong> <br/><br/>
        hygge se reserva el derecho a modificar la presente política para adaptarla 
        a futuras novedades legislativas o jurisprudenciales, así como a futuros usos 
        que proyecte realizar de los datos personales de los Usuarios de la Página Web. 
        En caso de que dicha modificación le afectara en lo relativo al tratamiento de 
        sus datos, por ejemplo, porque se va a realizar algún tratamiento de los mismos
        adicional, no informado previamente, procederíamos a notificarle de
        ello. Se recomienda al Usuario, en todo caso, que proceda a la lectura
        de la Política de Protección de Datos de Carácter Personal de la Página
        Web cada vez que vaya a acceder a la misma. <br/><br/>
        13. INTEGRACIÓN CON EL RESTO DE LOS TEXTOS LEGALES <br/><br/> Esta política de 
        privacidad se complementa con el Aviso Legal, la Política de Cookies y las 
        Condiciones de Contratación asociados a la presente Página Web. 
        </Typography>
        </Paper>
    </div>
  )
}
const useStyles = makeStyles((theme) => ({
  root:{
    minHeight:'100vh',
    backgroundColor:'#FEFCF3',
    display:'flex',
    justifyContent:'center',
    alignContent:'center',
  },
  paper:{
    maxWidth:'90vw',
    backgroundColor:'#FEFCF3',
    padding: theme.spacing(5)
    },
  title:{
    textAlign:'center',
    padding: theme.spacing(4,0,2,0),
    color:'#005795',
    fontWeight:'bold',
  },
  ul:{
    marginLeft: theme.spacing(5),
  },
  link:{
    color:'#005795',
    textDecoration:'none',
  }
}))

export default Politicas